<template>
  <div class="footer-bar">
  </div>
</template>

<script>
import { isLogin } from '@/utils/token'

export default {
  name: 'FooterBar',
  data () {
    return {
      activeMenu: 'home'
    }
  },
  watch: {
    $route: {
      handler (val) {
        if (val.name === 'home') {
          this.activeMenu = 'home'
        } else if (val.name === 'profile') {
          this.activeMenu = 'profile'
        } else if (val.name === 'live') {
          this.activeMenu = 'live'
        } else if (val.name === 'qa') {
          this.activeMenu = 'qa'
        }
      },
      immediate: true
    }
  },
  created: function () {
  },
  methods: {
    toRoute (path) {
      // if (path === '/vip' || path === '/profile') {
      if (path === '/douyin') {
        this.$weui.alert('抖音专区暂未开通')
        return
      }
      if (path === '/profile') {
        if (isLogin(this)) {
          this.$router.push(path)
        }
      } else {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
  @import "../../../styles/variables";
  .footer-bar {

  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/FooterBar.vue